var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSideCalendarActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.755,
    height: 20,
    viewBox: "0 0 22.755 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar_1_",
    "data-name": "calendar (1)",
    transform: "translate(0 -30.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3345",
    "data-name": "Path 3345",
    d: "M.666,161.655H18.088a.668.668,0,0,0,.427-.154c.167-.14,3.985-3.424,4.217-10.512H4.021c-.232,6.434-3.747,9.459-3.784,9.489a.667.667,0,0,0,.428,1.178Z",
    transform: "translate(0 -114.667)",
    fill: "#3160d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3346",
    "data-name": "Path 3346",
    d: "M109.02,32.321h-3.333v-.667a.667.667,0,0,0-1.333,0v.667h-3.378v-.667a.667.667,0,0,0-1.333,0v.667H96.309v-.667a.667.667,0,0,0-1.333,0v.667H91.643a.66.66,0,0,0-.667.667v2h18.711v-2A.66.66,0,0,0,109.02,32.321Z",
    transform: "translate(-86.933)",
    fill: "#3160d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3347",
    "data-name": "Path 3347",
    d: "M106.3,302.851a2.006,2.006,0,0,1-1.283.466H90.977v2a.666.666,0,0,0,.667.667h17.378a.666.666,0,0,0,.667-.667v-7.473A13.212,13.212,0,0,1,106.3,302.851Z",
    transform: "translate(-86.934 -254.995)",
    fill: "#3160d4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideCalendarActive);
export default __webpack_public_path__ + "static/media/sideCalendarActive.c874230fd4414e2e91903ea317f73af6.svg";
export { ForwardRef as ReactComponent };